import React from 'react'
import PeticionTraeDatos from '../hooks/useTraeDatos';
import { MDBTable, MDBTableBody } from 'mdbreact';
import HeaderTabla from '../componentes/HeaderTabla';
import Logo from '../../paginas/img/logo_fondo_negro.png'
const baseUrl = process.env.REACT_APP_BASE_URL
const api = process.env.REACT_APP_API
const urlConfiguraciones = baseUrl + api + 'configuraciones/'


const ImprimirProductos = React.forwardRef((props, ref) => {
    const [configuraciones] = PeticionTraeDatos(urlConfiguraciones)
    const dataConfiguracion = configuraciones ? configuraciones[16] : [];
    const alerta = dataConfiguracion ? JSON.parse(dataConfiguracion.valor) : []


    const Estado = (producto) => {
        let colorNotificacion = ''
        let textoNotificacion = ''

        if (producto.inventario === 'true') {

            let Agota = alerta[0] // tiene rangofin
            let PocasExis = alerta[1]
            let EnExis = alerta[2] //tiene rangoini

            let sumarInventario = parseInt(producto.inventarioCantidad)

            if (sumarInventario < parseInt(Agota?.rangofin)) {
                textoNotificacion = 'Agotado'
                colorNotificacion = 'Rojo'
            } else if (sumarInventario >= parseInt(PocasExis?.rangoini) && sumarInventario <= parseInt(PocasExis?.rangofin)) {
                textoNotificacion = 'Pocas Existencias'
                colorNotificacion = 'Amarillo'
            } else if (sumarInventario >= parseInt(EnExis?.rangoini)) {
                textoNotificacion = 'En Existencia'
                colorNotificacion = 'Verde'
            }
        }

        return {
            colorNotificacion,
            textoNotificacion
        }

    }


    return (
        <div ref={ref} className='m-4'>
            <div className='d-flex align-items-center'><img src={Logo} className="logoMenu mr-2" /><h4 className='m-0'>Informe de Productos:</h4></div>
            <hr />
            <MDBTable hover responsive>
                <HeaderTabla array={['Código', 'Producto', 'Categorías', 'Inventario']} />
                <MDBTableBody>
                    {
                        props.data.map((item, index) => {
                            let inventarioCantidad = item.inventario == "true" ? item.inventarioCantidad : null
                            let ArrayCategorias = item.categoria_producto
                            const { colorNotificacion, textoNotificacion } = Estado(item)
                            return (
                                <tr key={index} className="tabla_productos">
                                    <td>{item.id}</td>
                                    <td>{`${item.nombre_producto} ${item.nombre_Atributo !== null ? '- ' + item.nombre_Atributo : ''}`}</td>
                                    <td>{props.imprimeArray(ArrayCategorias, true)}</td>
                                    <td className='text-center'> {inventarioCantidad ? <div className={`${colorNotificacion} text-center notificacion`}>{inventarioCantidad}</div> : null} </td>

                                </tr>
                            )
                        })
                    }
                </MDBTableBody>
            </MDBTable>
        </div>
    );
});
export default ImprimirProductos